import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useStateInRef } from 'seagull';
import { useStore } from '~/store/store-context';
import { businessChannelNames } from './PusherBusinessChannelProvider.utils';
import { usePusher } from './PusherProvider';
const PusherBusinessChannelContext = /*#__PURE__*/ createContext({
    getChannel () {}
});
export const usePusherBusinessChannel = ()=>useContext(PusherBusinessChannelContext);
/** Responsible for subscribing/unsubscribing to the pusher business channel. */ export function PusherBusinessChannelProvider(props) {
    const pusher = usePusher();
    const userInfo = useStore((state)=>state.userInfo);
    const businessId = userInfo === null || userInfo === void 0 ? void 0 : userInfo.businessId();
    const [activeChannels, setActiveChannels] = useState();
    const getActiveChannels = useStateInRef(activeChannels);
    useEffect(()=>{
        if (businessId) {
            const names = businessChannelNames(businessId);
            pusher.subscribe(names.mgmt);
            pusher.subscribe(names.scout);
            setActiveChannels(names);
            return ()=>{
                pusher.unsubscribe(names.mgmt);
                pusher.unsubscribe(names.scout);
                setActiveChannels(undefined);
            };
        }
    }, [
        businessId
    ]);
    const getChannel = useCallback((source)=>{
        const names = getActiveChannels();
        return names ? pusher.channel(source === 'scout' ? names.scout : names.mgmt) : undefined;
    }, []);
    const channelBusinessId = activeChannels === null || activeChannels === void 0 ? void 0 : activeChannels.businessId;
    const value = useMemo(()=>{
        return {
            getChannel,
            channelBusinessId
        };
    }, [
        getChannel,
        channelBusinessId
    ]);
    return /*#__PURE__*/ _jsx(PusherBusinessChannelContext.Provider, {
        value: value,
        children: props.children
    });
}
